import React from 'react';

// Iniciais do primeiro e do último nome ("Adriano Lopes" -> "AL")
export const userInitials = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Foto quadrada do usuário; sem foto, um quadrado cinza com as iniciais
function UserPhoto({ user, size = 90, round = false, className = '' }) {
  const box = {
    width: size,
    height: size,
    borderRadius: round ? '50%' : 4,
    flexShrink: 0,
  };

  if (user?.photo_url) {
    return (
      <img
        src={user.photo_url}
        alt={user.name}
        loading="lazy"
        className={className}
        style={{ ...box, objectFit: 'cover', display: 'block' }}
      />
    );
  }

  return (
    <div
      title={user?.name}
      className={className}
      style={{
        ...box,
        backgroundColor: '#d2d6de',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: Math.round(size * 0.34),
        fontWeight: 600,
        letterSpacing: 1,
        userSelect: 'none',
      }}
    >
      {userInitials(user?.name)}
    </div>
  );
}

export default UserPhoto;
